import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { downloadProductPhotos } from '@/api/productPhotos';

@Component
export default class ProductPhotosDownload extends Vue {
    @Prop({ required: true }) article!: string;
    // compact — миниатюра в таблице, normal — карточка, large — страница товара
    @Prop({ default: 'normal' }) size!: 'compact' | 'normal' | 'large';
    // Показывать только при наведении на предка с классом product-photos-download-host
    @Prop({ type: Boolean, default: false }) revealOnHover!: boolean;

    loading = false

    // Vuetify 1.5 задаёт размер иконки инлайн-стилем, поэтому через проп, а не CSS
    get iconSize() {
        return { compact: 14, normal: 16, large: 22 }[this.size] || 16
    }

    async download() {
        if (this.loading) return
        this.loading = true
        try {
            await downloadProductPhotos(this.article)
        } catch (error) {
            this.$store.commit('modal:open', {
                type: 'error',
                msg: error.message,
            })
        }
        this.loading = false
    }
}
